import app from 'flarum/forum/app';
import { BooleanGambit } from 'flarum/common/query/IGambit';

/**
 * "est:en-ligne" in the member list's search: the members online now (the
 * header's "Membres connectés", addMembersMenu.tsx), filter[online] - see
 * OnlineFilter.php. The member list is for members only.
 */
export default class OnlineGambit extends BooleanGambit {
  key() {
    return app.translator.trans('champis-users.lib.gambits.users.online.key', {}, true);
  }
  filterKey() {
    return 'online';
  }
  enabled() {
    return !!app.session.user;
  }
}

/**
 * The member list filtered on the members online now: "est:en-ligne", both
 * words translated, as the gambit reads it.
 */
export function onlineQuery() {
  return new OnlineGambit().fromFilter('', false);
}
flarum.reg.add('champis-users', 'forum/query/OnlineGambit', OnlineGambit);